<a
  [routerLink]="['/a', 'gallery', gallery().id | removeIdPrefix, 'designer']"
  [class.compact]="compact()"
  draggable="false"
>
  <app-gallery-item
    [gallery]="gallery()"
    [compact]="compact()"
    [galleryPermissions]="gallery().permissions"
    [dateMode]="dateMode()"
  >
    <ng-container contentOnHover>
      <div class="buttons">
        <div class="spacer"></div>
        <app-context-menu
          [options]="{ width: '240px', noSpacing: true }"
          #menu
          [position]="'right'"
          contextHoverIdentifier="gallery-{{ gallery().id }}"
        >
          <button
            appButton
            name="options"
            data-test-id="gallery-options"
            location="gallery-item"
            [analyticsExtra]="{ galleryId: gallery()?.id }"
            [iconButton]="true"
            spacing="1"
            shape="round"
            [height]="compact() ? '0' : '1'"
            color="hard-simple"
            contextButton
          >
            <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
          </button>
          <div contextContent>
            @if (menu.isOpen()) {
              <app-gallery-context-menu [gallery]="gallery()" (onClose)="menu.close()"> </app-gallery-context-menu>
            }
          </div>
        </app-context-menu>
      </div>
    </ng-container>
    <ng-container contentAlways>
      <app-activity-badge
        [gallery]="gallery()"
        [hasLink]="true"
        [noBorder]="true"
        [hideWhenEmpty]="true"
        (click)="openActivityMenu($event, activityMenu)"
      >
      </app-activity-badge>
      <app-context-menu class="activity-context" [options]="{ width: '380px', noSpacing: true }" #activityMenu>
        <div contextContent>
          @if (activityMenu.isOpen()) {
            <app-gallery-activity-menu
              [gallery]="gallery()"
              (closeContext)="activityMenu.close()"
            ></app-gallery-activity-menu>
          }
        </div>
      </app-context-menu>
      <button
        appButton
        name="favorite"
        location="gallery-item"
        [iconButton]="true"
        shape="round"
        [height]="compact() ? '0' : '1'"
        color="hard-simple"
        class="favorite-button"
        (click)="toggleFavorite($event)"
        [class.favorited]="gallery().is_favourite"
      >
        @if (!gallery().is_favourite) {
          <app-svg src="/assets/icons/star-empty.svg"></app-svg>
        }
        @if (gallery().is_favourite) {
          <app-svg src="/assets/icons/star-filled.svg"></app-svg>
        }
      </button>
    </ng-container>
  </app-gallery-item>
</a>
